<template>
  <EmailConsentModal
    v-if="userStore.isAuthenticated"
    v-model="isOpen"
    :context="context"
  />
</template>

<script setup lang="ts">
import EmailConsentModal from "./email-consent-modal.vue";
import { useEmailConsentPrompt } from "@/composables/use-email-consent-prompt";
import { useUserStore } from "@/stores/user.store";

const userStore = useUserStore();
const { isOpen, context } = useEmailConsentPrompt();
</script>
